<template>
  <div class="space-y-1">
    <div class="relative">
      <span class="inline-block w-full rounded-md shadow-sm">
        <button
          type="button"
          aria-haspopup="listbox"
          aria-expanded="true"
          aria-labelledby="listbox-label"
          class="cursor-default relative w-full rounded-md border border-gray-300 bg-white pl-3 pr-10 py-4 text-left lg:text-lg focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
          @click="toggleSelect"
        >
          <div class="flex items-center space-x-3">
            <span class="block truncate" v-if="selected.label">
              {{ selected.label }}
            </span>
            <span class="block truncate text-gray-400" v-else>
              {{ placeholder }}
            </span>
          </div>
          <span
            class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
          >
            <Icon name="Selector" class="h-5 w-5 text-gray-400" />
          </span>
        </button>
      </span>

      <!--
      Select popover, show/hide based on select state.

      Entering: ""
        From: ""
        To: ""
      Leaving: "transition ease-in duration-100"
        From: "opacity-100"
        To: "opacity-0"
    -->
      <transition
        enter-active-class="transition ease-out duration-100 z-50"
        enter-class="opacity-0 z-50"
        enter-to-class="opacity-100 z-50"
        leave-active-class="transition ease-in duration-75 z-50"
        leave-class="opacity-100 z-50"
        leave-to-class="opacity-0 z-50"
      >
        <div
          v-show="isOpen"
          class="absolute mt-1 w-full rounded-md bg-white shadow-lg"
        >
          <ul
            tabindex="-1"
            role="listbox"
            aria-labelledby="listbox-label"
            aria-activedescendant="listbox-item-3"
            class="bg-white relative z-50 max-h-56 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
          >
            <!--
          Select option, manage highlight styles based on mouseenter/mouseleave and keyboard navigation.

          Highlighted: "text-white bg-indigo-600", Not Highlighted: "text-gray-900"
        -->
            <Option
              v-for="option in correctOptionsFormat"
              :key="option.value"
              @click="select(option)"
              >{{ option.label }}</Option
            >

            <!-- More options... -->
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/UI/Icon";
import Option from "./Option";
export default {
  components: { Option, Icon },
  props: {
    modelValue: String,
    options: Array,
    placeholder: String,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    correctOptionsFormat() {
      return this.options.map((item) => {
        if (typeof item === "string") {
          return {
            label: item,
            value: item,
          };
        }
        return {
          label: item.label || item.value,
          value: item.value || item.label,
        };
      });
    },
    selected: {
      get() {
        if (this.modelValue) {
          return this.correctOptionsFormat.find(
            (item) => item.value === this.modelValue
          ) || {
            label: "",
            value: "",
          };
        } else {
          return {
            label: "",
            value: "",
          };
        }
      },
      set(newValue) {
        this.$emit("update:modelValue", newValue.value);
      },
    },
  },
  watch: {
    isOpen(value) {
      if (!value) {
        document.removeEventListener("click", this.handleToggle);
      }
    },
  },
  methods: {
    select(item) {
      this.selected = item;
    },
    toggleSelect() {
      document.addEventListener("click", this.handleToggle);
    },
    handleToggle() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style></style>
